"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Button_1 = require("@mui/material/Button");
var Modal_1 = require("@mui/material/Modal");
var react_1 = require("react");
var TextField_1 = require("@mui/material/TextField");
var CloudUpload_1 = require("@mui/icons-material/CloudUpload");
var Stack_1 = require("@mui/material/Stack");
var Document_1 = require("../models/Document");
var material_1 = require("@mui/material");
var Toast_1 = require("../shared/utilities/Toast");
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
var VisuallyHiddenInput = styles_1.styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
var DocumentModal = react_1.forwardRef(function (props, ref) {
    var _a = React.useState(false), isInvalid = _a[0], setIsInvalid = _a[1];
    var _b = Toast_1.default(), showErrorMessage = _b.showErrorMessage, showSuccessMessage = _b.showSuccessMessage;
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var _d = React.useState(false), isMobile = _d[0], setIsMobile = _d[1];
    //choose the screen size 
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    };
    var handleOpen = function (document) {
        setOpen(true);
        setName(document.Name);
        setDescription(document.Description);
        setFileLocation(document.DocumentLocation);
        setId(document.DocumentId);
        setDisplaySequence(document.DisplaySequence);
        setFile(undefined);
        setIsInvalid(document.DocumentId !== '');
        window.addEventListener("resize", handleResize);
        handleResize();
    };
    var handleClose = function () {
        setOpen(false);
        window.removeEventListener("resize", handleResize);
    };
    var _e = React.useState(''), id = _e[0], setId = _e[1];
    var _f = React.useState(''), name = _f[0], setName = _f[1];
    var _g = React.useState(''), description = _g[0], setDescription = _g[1];
    var _h = React.useState(''), displaySequence = _h[0], setDisplaySequence = _h[1]; //TODO: allow only numbers
    var _j = React.useState(''), fileLocation = _j[0], setFileLocation = _j[1];
    var _k = React.useState(undefined), file = _k[0], setFile = _k[1];
    react_1.useImperativeHandle(ref, function () { return ({
        handleOpen: handleOpen
    }); });
    var handleNameChange = function (e) {
        setName(e.target.value);
    };
    var handleDescriptionChange = function (e) {
        setDescription(e.target.value);
    };
    var handleDisplaySequenceChange = function (e) {
        setDisplaySequence(e.target.value);
    };
    var handleFileChange = function (e) {
        var file = e.target.files[0];
        setFileLocation(URL.createObjectURL(file));
        setFile(file);
    };
    return (React.createElement(Modal_1.default, { open: open, onClose: handleClose, "aria-labelledby": "parent-modal-title", "aria-describedby": "parent-modal-description" },
        React.createElement(Box_1.default, { sx: __assign(__assign({}, style), { width: isMobile ? '90%' : '50%', overflowY: 'auto', maxHeight: '85%' }) },
            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "File Name", variant: "outlined", fullWidth: true, value: name, onChange: handleNameChange, error: isInvalid && name === "", helperText: isInvalid && name === "" ? 'Document name is required' : '', inputProps: { maxLength: 100 } }),
            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "File Description", variant: "outlined", fullWidth: true, value: description, onChange: handleDescriptionChange, inputProps: { maxLength: 250 } }),
            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Display Order", variant: "outlined", fullWidth: true, value: displaySequence, onChange: handleDisplaySequenceChange, inputProps: { maxLength: 2 } }),
            React.createElement(Button_1.default, { component: "label", variant: "contained", startIcon: React.createElement(CloudUpload_1.default, null) },
                "Upload Document",
                React.createElement(VisuallyHiddenInput, { type: "file", onChange: handleFileChange })),
            isInvalid && fileLocation === '' &&
                React.createElement(material_1.FormHelperText, { error: true }, "Document is required"),
            React.createElement("br", null),
            fileLocation !== '' && fileLocation !== null &&
                React.createElement("a", { href: fileLocation, download: true }, "View Document"),
            React.createElement("br", null),
            React.createElement(Stack_1.default, { spacing: 2, direction: "row", justifyContent: "flex-end" },
                React.createElement(Button_1.default, { variant: "outlined", onClick: function () {
                        handleClose();
                    } }, "Cancel"),
                React.createElement(Button_1.default, { variant: "contained", onClick: function () {
                        if (name.trim() === "" || fileLocation === '') {
                            setIsInvalid(true);
                            showErrorMessage('Document information is not valid!');
                            return;
                        }
                        var document = new Document_1.DocumentModel();
                        document.DocumentId = id;
                        document.Name = name;
                        document.Description = description;
                        document.DisplaySequence = displaySequence;
                        if (file != undefined) {
                            var reader_1 = new FileReader();
                            reader_1.readAsDataURL(file);
                            reader_1.onload = function () {
                                if (reader_1.result != null) {
                                    console.log('file name', file.name);
                                    props.upsertDocument(document, reader_1.result.toString().split('base64,')[1], file.name);
                                }
                            };
                            reader_1.onerror = function (error) {
                                console.log('Error: ', error);
                            };
                        }
                        else {
                            props.upsertDocument(document, null, null);
                        }
                        handleClose();
                    } }, "Confirm")))));
});
exports.default = DocumentModal;
//# sourceMappingURL=DocumentModal.js.map